module.exports = __webpack_public_path__ + "static/media/arrow-blue.efd2f7d9.svg";